// Delay so Elasticsearch can update before we fetch or navigate, then the list data is up to date
// When `then` is set: try once immediately, then wait and retry (so fast path is not slow).

export async function updateDelay(options?: {
  delayMs?: number
  times?: number
  delayMultiplier?: number
  then?: (attempt: number) => Promise<void>
}): Promise<void> {
  const hasThen = Boolean(options?.then)
  const delayMs = options?.delayMs ?? (hasThen ? 500 : 1000)
  const times = options?.times ?? (hasThen ? 3 : 1)
  const delayMultiplier = options?.delayMultiplier ?? 2

  if (options?.then) {
    await options.then(0)
    let currentDelay = delayMs
    for (let i = 1; i < times; i++) {
      const delay = currentDelay
      await new Promise((resolve) => setTimeout(resolve, delay))
      await options.then(i)
      currentDelay *= delayMultiplier
    }
  } else {
    let currentDelay = delayMs
    for (let i = 0; i < times; i++) {
      const delay = currentDelay
      await new Promise((resolve) => setTimeout(resolve, delay))
      currentDelay *= delayMultiplier
    }
  }
}
